export const productPriceLockedAttr = {
  productNested: {
    as: "priceLocked",
    value: { path: ["product", "product_group", "product_group_master", "priceLocked"] },
  },
  product: {
    as: "priceLocked",
    value: { path: ["product_group", "product_group_master", "priceLocked"] },
  },
}
